import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import './StepNav.css';

// 모듈B 4단계 스텝 네비게이션 (1→2→3→4)
export const MODULE_B_STEPS = [
  { step: 1, path: '/module-b/sync', key: 'sync' },
  { step: 2, path: '/module-b/features', key: 'features' },
  { step: 3, path: '/module-b/fusion', key: 'fusion' },
  { step: 4, path: '/module-b/judgment', key: 'judgment' },
];

function StepNav({ current, shotId }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const query = shotId ? `?shot=${shotId}` : '';

  return (
    <div className="mb-stepnav">
      <div className="mb-stepnav-brand">
        <span className="material-symbols-outlined mb-stepnav-brand-icon">hub</span>
        <div className="mb-stepnav-brand-text">
          <div className="mb-stepnav-brand-title">{t('pages.moduleb.nav.brandTitle')}</div>
          <div className="mb-stepnav-brand-sub">S = α·Sᵥ + β·Sₚ + γ·Sₜ &nbsp;({t('pages.moduleb.nav.brandSub')})</div>
        </div>
      </div>

      <div className="mb-stepnav-steps">
        {MODULE_B_STEPS.map((s, idx) => {
          const state = s.step === current ? 'active' : s.step < current ? 'done' : 'todo';
          return (
            <React.Fragment key={s.step}>
              <button
                type="button"
                className={`mb-step mb-step-${state}`}
                onClick={() => navigate(`${s.path}${query}`)}
              >
                <span className="mb-step-circle">
                  {state === 'done' ? (
                    <span className="material-symbols-outlined mb-step-check">check</span>
                  ) : (
                    s.step
                  )}
                </span>
                <span className="mb-step-labels">
                  <span className="mb-step-title">{t(`pages.moduleb.nav.steps.${s.key}.title`)}</span>
                  <span className="mb-step-desc">{t(`pages.moduleb.nav.steps.${s.key}.desc`)}</span>
                </span>
              </button>
              {idx < MODULE_B_STEPS.length - 1 && (
                <span className={`mb-step-connector ${s.step < current ? 'filled' : ''}`}>
                  <span className="material-symbols-outlined">chevron_right</span>
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default StepNav;
